import React from 'react';
import ArrayUtil from '@leverege/array-util';
import { GlobalState } from '@leverege/ui-redux';
import { Toast, Dialogs } from '@leverege/ui-elements';
import { EditorDialog } from '@leverege/ui-plugin';
import { UserValidator } from '@leverege/api-validator';
import I18N from '@leverege/i18n';
import Rsrc from "../../Rsrc.js";
import Icons from "../../Icons.js";
import CreateTemporaryUserEditor from "./CreateTemporaryUserEditor.js";
import ShareTemporaryUserAccess from "./ShareTemporaryUserAccess.js";
/**
 * Add user dialog.
 */
const {
  t
} = I18N.ns('temporaryUserManagement.CreateDialog');
export default class CreateTemporaryUserDialog extends React.Component {
  /**
   * Constructs component.
   */
  constructor(props) {
    super(props);
    this.state = {
      actionState: null
    };
  }

  /**
   * Handles adding users.
   */
  onOkay = async evt => {
    const {
      actions,
      onClose
    } = this.props;
    const {
      value
    } = evt;
    this.setState({
      actionState: 'saving'
    });
    try {
      const temporaryUser = await GlobalState.dispatch(actions.temporaryUsers().create({
        id: value.id,
        expiresAt: value.expiresAt,
        description: value.description,
        roles: value.roles.map(role => ({
          domain: role.domain,
          name: role.name,
          projectId: role.projectId
        })),
        email: [],
        phone: []
      }));
      this.setState({
        actionState: null
      });
      onClose?.();
      Dialogs.show({
        id: 'temporaryUserManagement.action.PostCreateShare',
        component: ShareTemporaryUserAccess,
        props: {
          ...this.props,
          temporaryUser
        }
      });
      return temporaryUser;
    } catch (err) {
      console.warn(err);
      this.setState({
        actionState: null
      });
      Toast.error(t('errorToast'));
    }
  };

  /**
   * Validator to enable submission button.
   */
  validator(curVal, val) {
    return curVal != null && curVal.id != null && curVal.expiresAt != null && curVal.validAfter != null && curVal.roles != null && curVal.roles.length > 0;
  }

  /**
   * Renders component.
   */
  render() {
    // Get parameters
    const {
      show,
      onClose,
      projectId,
      selectorProps,
      systemId,
      actions,
      Selector,
      allowed,
      edit,
      user,
      editorVariants,
      getResourceName
    } = this.props;
    const {
      actionState
    } = this.state;
    // Render component
    return /*#__PURE__*/React.createElement(EditorDialog, {
      actionState: actionState,
      icon: Icons.createTemporaryUserDialogIcon,
      title: t('title'),
      okayLabel: t('okay'),
      cancelLabel: t('cancelLabel'),
      eventData: {
        ...this.props,
        emailOptions: {
          systemId
        }
      },
      show: show,
      onClose: onClose,
      onOkay: this.onOkay,
      validator: this.validator,
      paneVariant: "tempUserEditorDialog|editorDialog",
      editor: CreateTemporaryUserEditor,
      editorVariants: {
        pane: 'tempUserEditor|tempUser|userEditor|rootEditor|form',
        header: 'tempUserEditorHeader|userEditorHeader|rootEditorHeader|formHeader',
        body: 'tempUserEditorBody|formBody',
        title: 'tempUserEditorTitle|userEditorTitle|rootEditorTitle|formTitle',
        footer: 'tempUserEditorFooter|userEditorFooter|rootEditorFooter|formFooter',
        ...editorVariants
      },
      editorProps: {
        canCreateUsers: allowed?.createUser || false,
        selectorProps,
        projectId,
        actions,
        edit,
        user,
        roleSelector: Selector,
        getResourceName
      }
    });
  }
}